import {WritableAtom, atom} from 'nanostores';

export interface IAppSecrets {
  googleApiKey: string;
  primeDocApiUrl: string;
  securePayHost: string;
  securePayClientId: string;
  securePayMerchantCode: string;
  auth0DomainURL: string;
  auth0ClientID: string;
  openReplayProjectKey: string;
  openReplayIngestPoint: string;
  auth0CallbackUrl: string;
  auth0LogoutUrl: string;
  featureSwitchCompany: string;
  featureSwitchAbn: string;
}

export const isMenuOpen: WritableAtom<boolean> = atom(true);

export const $appSecrets: WritableAtom<IAppSecrets> = atom({googleApiKey: ''});

export const $isVerifyingCreditCard: WritableAtom<boolean> = atom(false);
